module.exports = __webpack_public_path__ + "img/HK.76aa7532.svg";